// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import { RadioGroup as BaseRadioGroup } from 'react-radio-group';
import { Grid } from 'src/components/HTKit/Grid';
// Helpers
import { getAnswerComponents, getColumnGroups, getGridColumnStyles } from '../helpers';
// Data
import { DEFAULT_QUESTIONS_PER_COLUMN } from '../constants';
// Styles
import styles from '../styles.scss';

const AnswersContainer = ({
  answers = [],
  questionsPerColumn = DEFAULT_QUESTIONS_PER_COLUMN,
  setElementClicked = () => {},
  setSelectedAnswer = () => {},
  launchAdditionalInfoDisplay = () => {},
  wrapperStyle,
  ...rest
}) => {
  const isRowLayout = answers.find((a) => a && a.additionalInfo);
  const appliedStyles = cn('site-v2', wrapperStyle);
  const answerComponents = getAnswerComponents({
    answers,
    setElementClicked,
    setSelectedAnswer,
    launchAdditionalInfoDisplay,
  });
  const columns = getColumnGroups({ answerComponents, questionsPerColumn });
  const isMultiColumn = columns.length > 1;
  const mappingArray = isRowLayout ? answerComponents : columns;
  const gridColumnValues = getGridColumnStyles(isMultiColumn, isRowLayout);
  const overrideStyles = isMultiColumn && !isRowLayout ? styles.overrideColumn : '';

  return (
    <article className={appliedStyles}>
      <BaseRadioGroup {...rest}>
        <Grid.Fluid classes={styles.gridContainer}>
          <Grid.Row classes={overrideStyles}>
            {mappingArray.map((answer, index) => (
              <Grid.Column
                {...gridColumnValues}
                key={`column${index}`}
                classes={styles.overrideGridColumn}
              >
                {answer}
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid.Fluid>
      </BaseRadioGroup>
    </article>
  );
};

AnswersContainer.propTypes = {
  answers: PropTypes.array,
  setElementClicked: PropTypes.func,
  setSelectedAnswer: PropTypes.func,
  questionsPerColumn: PropTypes.number,
  wrapperStyle: PropTypes.string,
  launchAdditionalInfoDisplay: PropTypes.func,
};

export default AnswersContainer;

/*
  Layouts
  -------
  Beginning with the Booking Add-on Refresh ticket (https://hellotech.atlassian.net/browse/SFR-556) there became a need to render answers in
  a row format and not columns for certain answersthe desktop View.

  Column Desktop (legacy) Layout Example
  ---------------
  answer1 answer4
  answer2 answer5
  answer3 answer6

  Row Desktop (new) Layout Example
  ------------
  answer1 answer2
  answer3 answer4
  answer5 answer6

  Legacy/New Mobile/Tablet Layout Example
  ----------------------------------------
  answer1
  answer2
  answer3
  answer4
  answer5
  answer6
*/
